import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { Layout } from '@/components/layout';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import React from 'react';
import HeroSimple from '@/sections/HeroSimple';
import { PersonalDataForm } from '@/sections/personalDataRequests/PersonalDataForm';
import { ConfirmSection } from '@/sections/personalDataRequests/ConfirmSection';
import { MoreInfo } from '@/sections/personalDataRequests/MoreInfo';
import { SeoHeader } from '@/components/SeoHeader';
import { Text } from '@/components/typography';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(28);
  const {
    menuPromoBanners
  } = t0;
  usePageView("personalDataRequests");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["personalDataRequests", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const router = useRouter();
  const {
    token
  } = router.query;
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("banner.title");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("banner.text");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Text variant="p1" className="mt-4 text-gray-800 lg:mt-8">{t6}</Text>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t5 || $[15] !== t7) {
    t8 = <HeroSimple title={t5} contentClassName="max-w-192 mx-auto">{t7}</HeroSimple>;
    $[14] = t5;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== token) {
    t9 = <div className="px-4"><div className="relative z-10 mx-auto max-w-192 pb-20 lg:pb-40">{token && typeof token === "string" ? <ConfirmSection token={token} isRefund={false} /> : <PersonalDataForm />}</div></div>;
    $[17] = token;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <div className="bg-blue-50">{t8}{t9}</div>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="relative overflow-hidden bg-blue-100"><div className="relative z-10"><MoreInfo /></div><div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" /></div>;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== menuPromoBanners || $[25] !== t10 || $[26] !== t4) {
    t13 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t10}{t11}{t12}</Layout>;
    $[24] = menuPromoBanners;
    $[25] = t10;
    $[26] = t4;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
export const getStaticProps: GetStaticProps = async ctx => ({
  props: {
    menuPromoBanners: await getAllPageMenuPromoBanners(),
    ...(await getIntlProps(ctx, ['core', 'personalDataRequests']))
  }
});